import { AfterViewInit, Directive, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[matTooltipCta]'
})
export class MatTooltipCtaDirective implements AfterViewInit {

    @Input() matTooltipCta: string;

    constructor(private tooltip: MatTooltip) { }

    ngAfterViewInit(): void {   
        
        setTimeout(() => {
            this.tooltip.show();
            setTimeout(() => this.tooltip.hide(), this.getDuration());
        }, 2000);
    }

    private getDuration(): number {
        return this.matTooltipCta.indexOf('ms') > -1 ? 
            parseFloat(this.matTooltipCta.replace('ms', '')) :
            parseFloat(this.matTooltipCta.replace('s', '')) * 1000; 
    }
}
